import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Attribute} from "@/modules/redactor/models/attribute/Attribute";

export class Attributes extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Attributes, v) : SKIP;
            },
            (v) => {
                return deserialize(Attributes, v);
            }
        );
    }

    constructor() {
        super();
        this._items = [];
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    valid() {

        if (this.items && this.items.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.items || this.items.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Attributes());
        } else if (target instanceof Attributes) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Attributes, {
    _items: alias("items", list(Attribute.schema()))
});